import type { ReactNode } from "react"
import { useTableContext } from "./table.context"

export type TableRowToolbarProps<TData = unknown> = {
  /** Column id where the toolbar should appear */
  column: string
  /** Render function receiving the row data */
  children(row: TData): ReactNode
}

/**
 * Registers a row toolbar that appears on hover inside the specified column cell.
 * Renders no DOM — it only configures the toolbar via context.
 *
 * @example
 * ```tsx
 * <Table.RowToolbar column="Name">
 *   {(customer) => <TooltipButton ... />}
 * </Table.RowToolbar>
 * ```
 */
function TableRowToolbar<TData = unknown>(props: TableRowToolbarProps<TData>) {
  const { column, children } = props
  const { rowToolbarRef } = useTableContext()

  rowToolbarRef.current = {
    column,
    render: children as (row: unknown) => ReactNode,
  }

  return null
}

export default TableRowToolbar
